export enum MachineSoftwareUpdateState {
  UNKNOWN = 0,
  CHECKING_FOR_UPDATES = 1,
  WAITING_FOR_USER_CONFIRMATION = 2,
  WAITING_FOR_ACTIVE_ESTOP = 3,
  WAITING_FOR_UPDATE_TO_COMPLETE = 4,
  UPDATE_COMPLETED_SUCCESS = 5,
  UPDATE_COMPLETED_FAIL = 6
}
